import missionAllowList from "../../config/MissionAllowList";
import { isJrAccessKey } from "../../config/JrConfig";

const isNonEmptyString = (value) =>
  typeof value === "string" && value.length > 0;

const isValidMission = (mission) =>
  mission &&
  typeof mission === "object" &&
  isNonEmptyString(mission.missionId);

const isValidAllowListEntry = (entry) =>
  entry &&
  typeof entry === "object" &&
  Array.isArray(entry.missionIds) &&
  Array.isArray(entry.missionNames) &&
  Array.isArray(entry.missionNamePatterns);

const matchesAllowList = (mission, entry) => {
  if (!isValidMission(mission) || !isValidAllowListEntry(entry)) {
    return false;
  }

  if (entry.missionIds.includes(mission.missionId)) {
    return true;
  }

  if (isNonEmptyString(mission.missionName) &&
      entry.missionNames.includes(mission.missionName)) {
    return true;
  }

  return isNonEmptyString(mission.missionName) &&
    entry.missionNamePatterns.some(
      (pattern) => isNonEmptyString(pattern) &&
        mission.missionName.includes(pattern)
    );
};

const getProviderAllowList = (providerKey, configuration) => {
  if (!configuration || typeof configuration !== "object") {
    return null;
  }

  const entry = configuration[providerKey];
  return isValidAllowListEntry(entry) ? entry : null;
};

const filterMissions = (
  missions,
  providerKey,
  { isDeaAdmin = false, isDeaOverallMode = false } = {},
  configuration = missionAllowList
) => {
  if (!Array.isArray(missions)) {
    return [];
  }

  if (isDeaAdmin && isDeaOverallMode) {
    return deduplicateMissions(missions);
  }

  const entry = getProviderAllowList(providerKey, configuration);
  if (!entry) {
    return [];
  }

  return deduplicateMissions(
    missions.filter((mission) => matchesAllowList(mission, entry))
  );
};

const deduplicateMissions = (missions) => {
  const seenMissionIds = new Set();

  return missions.filter((mission) => {
    if (!isValidMission(mission) || seenMissionIds.has(mission.missionId)) {
      return false;
    }

    seenMissionIds.add(mission.missionId);
    return true;
  });
};

const getJrMissionScope = (accessKey, missionId) => {
  const isJr = isJrAccessKey(accessKey);
  if (!isJr) {
    return { isJr: false, allowed: true, missionId };
  }

  const normalizedMissionId = typeof missionId === "string" ? missionId.trim() : "";
  return {
    isJr: true,
    allowed: missionAllowList.jr.missionIds.includes(normalizedMissionId),
    missionId: normalizedMissionId,
  };
};

const jrMissionNameToId = Object.freeze({
  "男鹿駅": "cmvnjm7l600020klc2sb7ccdd",
  "羽立駅": "cmvnjm7la000t0klc646wc3th",
  "脇本駅": "cmvnjm7ld001m0klc6hsjh6z8",
  "船越駅": "cmvnjm7lg002m0klce2m364fx",
  "天王駅": "cmvnjm7li003k0klcepr13f0t",
  "二田駅": "cmvnjm7lk004b0klce835ejv2",
  "上二田駅": "cmvnjm7lm004x0klch47ndi57",
  "出戸浜駅": "cmvnjm7lo005c0klc1xqk0jfh",
});

const resolveJrMissionId = (missionId, missionName) => {
  if (missionId) {
    return missionAllowList.jr.missionIds.includes(missionId) ? missionId : "";
  }
  return jrMissionNameToId[missionName] || "";
};

const isJrDateRangeAllowed = (dateFrom, dateTo, minDate, maxDate) => {
  const from = new Date(dateFrom);
  const to = new Date(dateTo);
  const min = new Date(minDate);
  const max = new Date(maxDate);
  if ([from, to, min, max].some((value) => Number.isNaN(value.getTime()))) {
    return false;
  }
  return from.getTime() <= to.getTime() &&
    from.getTime() >= min.getTime() &&
    to.getTime() <= max.getTime();
};

export {
  deduplicateMissions,
  filterMissions,
  getProviderAllowList,
  matchesAllowList,
  getJrMissionScope,
  resolveJrMissionId,
  isJrDateRangeAllowed,
};


